import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  separator: {
    color: tokens.colorNeutralForeground3,
  },
  current: {
    color: tokens.colorNeutralForeground1,
  },
  link: {
    color: tokens.colorNeutralForeground2,
    ':hover': {
      color: tokens.colorNeutralForeground1,
    },
  },
});

const Breadcrumbs = ({ items }) => {
  const styles = useStyles();

  return (
    <nav className="flex items-center space-x-2 text-sm">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <React.Fragment key={item.path}>
            {index > 0 && <span className={styles.separator}>/</span>}
            {isLast ? (
              <span className={`font-medium ${styles.current}`}>{item.label}</span>
            ) : (
              <Link to={item.path} className={`transition-colors ${styles.link}`}>
                {item.label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
